import { Link } from "react-router-dom";

const columns = [
  {
    title: "内容导航",
    links: [
      { to: "/", label: "首页" },
      { to: "/category", label: "影视分类" },
      { to: "/topic", label: "影视专题" },
      { to: "/search", label: "搜索" },
    ],
  },
  {
    title: "热门入口",
    links: [
      { to: "/category?type=电影", label: "电影" },
      { to: "/category?type=电视剧", label: "电视剧" },
      { to: "/topic", label: "专题分析" },
      { to: "/about", label: "关于我们" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-gradient-to-b from-primary-900 to-primary-950 text-primary-100">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-16">
          <div className="lg:w-1/2">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-background-50 flex items-center justify-center">
                <i className="ri-moon-fill text-lg"></i>
              </span>
              <span className="text-background-50 font-heading font-bold text-lg tracking-wide">
                夜勤病栋
              </span>
            </div>
            <p className="text-sm leading-relaxed text-primary-200 max-w-lg">
              夜勤病栋是聚焦夜勤题材影视作品的内容站，为影迷与影视爱好者提供最新的电影电视剧资讯、剧情介绍与专题分析。本站仅展示文字与图片资讯，不提供播放与下载功能。
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8 lg:w-1/2">
            {columns.map((col) => (
              <div key={col.title}>
                <h3 className="text-background-50 text-sm font-semibold mb-3">{col.title}</h3>
                <ul className="space-y-2">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.to}
                        className="text-sm text-primary-200 hover:text-accent-300 transition-colors"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-700/50 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-primary-300">
            © {new Date().getFullYear()} 夜勤病栋 · 影视内容站　内容整理与编辑：夜勤病栋编辑部
          </p>
          <p className="text-xs text-primary-300">
            站内资讯为演示内容，用于展示页面结构。
          </p>
        </div>
      </div>
    </footer>
  );
}